<template>
<div class="scorecard_editor" v-show="$store.state.document_editor.show_modal">
<div class="scorecard_editor_inner">

<div class="flex align-items-center justify-content-end">
<i class="pi pi-times m-2" style="font-size: 1.5rem;cursor: pointer;" @click="closeModal"></i>
</div>


<div class="grid">
<div class="col-9 flex justify-content-center editor_pdf_area_holder" >

<div class="editor_pdf_area">
	<template v-if="loading">
		<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
		<FrameOverlay></FrameOverlay>
		<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
		<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
	</template>
	

	<canvas ref="canvas" width="1588" height="2246"></canvas>


	

</div>

</div>

<div class="col-3 editor_controllers_area_holder">
<!-- editor_controllers_area-->

<div class="editor_controllers_area">


<div>






<TabView v-model:activeIndex="activetab">





<!-- layers -->
<TabPanel header="Layers">

<!-- add item -->
<div class="grid" v-if="canvas">
<div class="col-12">
<Button   label="Textbox" class=" p-button-primary p-button-outlined  p-button-sm mr-2" @click="addTextBox"></Button>
<Button   label="Image" class=" p-button-primary p-button-outlined  p-button-sm mr-2" @click="addImage" :loading="imageuploading"></Button>

<Button   label="Data" class=" p-button-primary p-button-outlined  p-button-sm mr-2" @click="addData"></Button>




<input type="file" ref="imageuploader" class="hidden"  @change="uploadImage">

</div>
</div>
<!-- add item -->



<!-- item selector -->
<div class="grid" v-if="canvas && canvas._objects.length">
<div class="col-12">

<h4 class="text-primary">Design Layers</h4>
<hr>

</div>

<div class="col-12" v-for="(layer,index) in canvas_objects">

<div class="grid zebra_grid animate_class">
<div class="col-10">
<p :class="'my-1 text-'+is_selected(layer)" @click="editItem(index)">{{getItemName(index)}}</p>
</div>
<div class="col-2">
<Button icon="pi pi-trash"  class="p-button-danger p-button-outlined  p-button-rounded  p-button-sm  " @click="deleteLayer(index)"/>
	</div>

</div>



</div>
</div>
<!-- item selector -->



</TabPanel>

<!-- layers -->



<!-- active layer -->
<TabPanel header="Active Layer">




<!-- image controllers -->
<div class="grid mt-0 " v-if="selectedobjtype=='image'" >

<div class="col-12 p-0">
<h2 class="text-purple-500 my-0">Adjust Image</h2>
<hr>
</div>



<!-- image width -->

<div class="col-4"><p class="my-1">Scale: (<small>{{getFraction(selectedobj.sliderscale)}}</small>)</p></div>
<div class="col-8">
<Slider 
v-model="selectedobj.sliderscale" 
class="w-full p-inputtext-sm  mt-2" 
@change="imageScaleUpdated"
:max="5"
:step="0.1"
 />
</div>
<!-- image width -->




<!-- image width -->
<!--
<div class="col-4"><p class="my-1">Width: (<small>{{getFraction(selectedobj.scaleY)}}</small>)</p></div>
<div class="col-8">
<Slider 
v-model="selectedobj.scaleY" 
class="w-full p-inputtext-sm  mt-2" 
@change="imageScaleYUpdated"
:max="10"
:step="0.1"
 />
</div>
-->
<!-- image width -->

<!-- image height -->
<!--
<div class="col-4"><p class="my-1">Height: (<small>{{getFraction(selectedobj.scaleX)}}</small>)</p></div>
<div class="col-8">
<Slider 
v-model="selectedobj.scaleX" 
class="w-full p-inputtext-sm  mt-2" 
@change="imageScaleXUpdated" 
:max="10"
:step="0.1"
/>
</div>
-->
<!-- image height -->




<!-- image left -->
<div class="col-4"><p class="my-1">Left</p></div>
<div class="col-8">
<InputText
type="number" 
v-model="selectedobj.left" 
class="w-full p-inputtext-sm  mt-0" 
placeholder="Text" 
v-on:keyup.enter="textLeftUpdated"  
v-on:keyup.esc="textLeftUpdated" 
ref="inputarea"  
@update:modelValue="textLeftUpdated"

/>
</div>
<!-- image left -->


<!-- image top -->
<div class="col-4"><p class="my-1">Top</p></div>
<div class="col-8">
<InputText
type="number" 
v-model="selectedobj.top" 
class="w-full p-inputtext-sm  mt-0" 
placeholder="Text" 
v-on:keyup.enter="textTopUpdated"  
v-on:keyup.esc="textTopUpdated" 
ref="inputarea"  
@update:modelValue="textTopUpdated"
/>
</div>
<!-- image top -->

</div>
<!-- image controllers -->










<!-- textbox controllers -->
<div class="grid mt-0 " v-if="selectedobjtype=='textbox' || selectedobjtype=='text'" >


<div class="col-12 p-0" v-if="selectedobjtype=='textbox'">
<h2 class="text-purple-500 my-0">Adjust Textbox</h2>
<hr>
</div>

<div class="col-12 p-0" v-if="selectedobjtype=='text'">
<h2 class="text-purple-500 my-0">Adjust Data</h2>
<hr>
</div>



<!-- controller -->

<template v-if="selectedobjtype=='textbox'">
	


<div class="col-4"><p class="my-1">Text</p></div>
<div class="col-8">
<InputText
type="text" 
v-model="selectedobj.text" 
class="w-full p-inputtext-sm  mt-0" 
placeholder="Text" 
v-on:keyup.enter="textUpdated"  
v-on:keyup.esc="textUpdated" 
ref="inputarea"  
@update:modelValue="textUpdated"
/>
</div>
</template>
<!-- controller -->





<!-- data controllers -->
<template v-if="selectedobjtype=='text'">
	
<!-- controller -->
<div class="col-4"><p class="my-1">Data Type</p></div>
<div class="col-8">

<Dropdown
v-model="selected_datatype" 
:options="datatypes" 
placeholder="Select Data Type" 
class="w-full p-inputtext-sm  mt-0" 
@change="dataTypeUpdated"
optionLabel="name"
optionValue="id"
/>
</div>
<!-- controller -->



<!-- custom attribute selected -->
<!-- controller -->
<template v-if="selected_datatype=='customattribute'">
	

<div class="col-4"><p class="my-1">Attribute</p></div>
<div class="col-8">

<Dropdown
v-model="selected_customattribute" 
:options="customattributes" 
placeholder="Select Attribute" 
class="w-full p-inputtext-sm  mt-0" 
@change="customAttributeSelected"
optionLabel="name"
optionValue="id"
:loading="loading_custom_attributes"
/>
</div>
</template>
<!-- controller -->
<!-- custom attribute selected -->





<!-- reportcolumn selected -->
<template v-if="selected_datatype=='reportcolumn'">
	
<!-- controller -->
<div class="col-4"><p class="my-1">Report</p></div>
<div class="col-8">

<Dropdown
v-model="selected_report" 
:options="reports" 
placeholder="Select Report" 
class="w-full p-inputtext-sm  mt-0" 
@change="reportSelected"
optionLabel="name"
optionValue="id"
:loading="loading_reports"
/>
</div>
<!-- controller -->

<template v-if="selected_report">
<!-- controller -->
<div class="col-4"><p class="my-1">Column</p></div>
<div class="col-8">

<Dropdown
v-model="selected_reportcolumn" 
:options="reportcolumns" 
placeholder="Select Column" 
class="w-full p-inputtext-sm  mt-0" 
@change="reportColumnSelected"
optionLabel="name"
optionValue="id"
:loading="loading_reportcolumns"
/>
</div>
<!-- controller -->	
</template>


</template>
<!-- reportcolumn selected -->






</template>
<!-- data controllers -->






<!-- controller -->
<div class="col-4"><p class="my-1">Font Family</p></div>
<div class="col-8">

<Dropdown
v-model="selectedobj.fontFamily" 
:options="fonts" 
placeholder="Select a Font Family" 
class="w-full p-inputtext-sm  mt-0" 
@change="textFontFamilyUpdated"
/>

</div>
<!-- controller -->


<!-- controller -->
<div class="col-4"><p class="my-1">Color</p></div>
<div class="col-8">
<div class="grid">
<div class="col-3">
<ColorPicker 
v-model="selectedobj.fill" 
@update:modelValue="textColorUpdated"
:baseZIndex="10010"
class="mt-2"
/>
</div>
<div class="col-9">

<InputText
type="text" 
v-model="selectedobj.fill" 
class="w-full p-inputtext-sm  mt-0" 
placeholder="Text" 
v-on:keyup.enter="textColorUpdated"  
v-on:keyup.esc="textColorUpdated" 
@update:modelValue="textColorUpdated"
/>


</div>
</div>

</div>
<!-- controller -->

<!-- controller -->
<div class="col-4"><p class="my-1">Font Size: (<small>{{Math.ceil(selectedobj.fontSize)}}</small>)</p></div>
<div class="col-8">
<Slider 
v-model="selectedobj.fontSize" 
class="w-full p-inputtext-sm  mt-2" 
@change="textFontsizeUpdated" />
</div>
<!-- controller -->

<!-- controller -->
<div class="col-4"><p class="my-1">Text Align: </p></div>
<div class="col-8">

<SelectButton 
v-model="selectedobj.textAlign" 
:options="alignoptions" 
optionLabel="value" 
dataKey="value" 
aria-labelledby="custom" 
class="w-full p-inputtext-sm  mt-0" 
@change="textAlignUpdated"
>
<template #option="slotProps">
<i :class="slotProps.option.icon"></i>
</template>
</SelectButton>
</div>
<!-- controller -->


<!-- controller -->
<div class="col-4"><p class="my-1">Font Weight: </p></div>
<div class="col-8">

<SelectButton 
v-model="selectedobj.fontWeight" 
:options="weightoptions" 
aria-labelledby="basic" 
class="w-full p-inputtext-sm  mt-0" 
@change="textFontWeightUpdated"
>

</SelectButton>
</div>
<!-- controller -->




<!-- controller -->
<div class="col-4"><p class="my-1">Width: (<small>{{Math.ceil(selectedobj.width)}}</small>)</p></div>
<div class="col-8">
<Slider 
v-model="selectedobj.width" 
class="w-full p-inputtext-sm  mt-2" 
@change="textWidthUpdated"
:max="1588"
 />
</div>
<!-- controller -->

<!-- controller -->
<div class="col-4"><p class="my-1">Height: (<small>{{Math.ceil(selectedobj.height)}}</small>)</p></div>
<div class="col-8">
<Slider 
v-model="selectedobj.height" 
class="w-full p-inputtext-sm  mt-2" 
@change="textHeightUpdated" 
:max="500"
/>
</div>
<!-- controller -->

<!-- controller -->
<div class="col-4"><p class="my-1">Left</p></div>
<div class="col-8">
<InputText
type="number" 
v-model="selectedobj.left" 
class="w-full p-inputtext-sm  mt-0" 
placeholder="Text" 
v-on:keyup.enter="textLeftUpdated"  
v-on:keyup.esc="textLeftUpdated" 
ref="inputarea"  
@update:modelValue="textLeftUpdated"
/>
</div>
<!-- controller -->


<!-- controller -->
<div class="col-4"><p class="my-1">Top</p></div>
<div class="col-8">
<InputText
type="number" 
v-model="selectedobj.top" 
class="w-full p-inputtext-sm  mt-0" 
placeholder="Text" 
v-on:keyup.enter="textTopUpdated"  
v-on:keyup.esc="textTopUpdated" 
ref="inputarea"  
@update:modelValue="textTopUpdated"
/>
</div>
<!-- controller -->


</div>

<!-- textbox controllers -->



</TabPanel>
<!-- active layer -->




<!-- pages -->

<TabPanel header="Pages">
<div class="grid">

<div class="col-12">

<Button   label="New Page" class=" p-button-primary p-button-outlined  p-button-sm mr-2" @click="addNewPage"></Button>
<Button   label="Preview" class=" p-button-info p-button-outlined  p-button-sm mr-2" @click="downloadPdf"></Button>
</div>




<div class="col-12" v-for="(page,index) in translation">

<div class="grid zebra_grid animate_class">
<div class="col-10">
<p class="my-1 " 
:class="isPageActive(index)"
@click="selectPage(index)">{{index+1}}. sayfa</p>
</div>
<div class="col-2">
<Button v-if="index!==0" icon="pi pi-trash"  class="p-button-danger p-button-outlined  p-button-rounded  p-button-sm  " @click="deletePage(index)"/>
	</div>
</div>



</div>
</div>


</TabPanel>
<!-- pages -->


</TabView>





</div>


<Button   label="Save" class="w-full p-button-primary p-button-outlined  p-button-sm mt-2" @click="updatePage"></Button>




</div>
<!-- editor_controllers_area-->






</div>

</div>
</div>
</div>
</template>

<script>
import { fabric } from 'fabric';
import { jsPDF } from "jspdf";
export default {

  name: 'BrandSupplierScorecardEditor',

  data () {
    return {
    	translation:null,
    	activepageindex:0,
    	loading:true,
    	imageuploading:false,
    	customattributes:[],
    	reports:[],
    	reportcolumns:[],
    	projects:[],
    	flows:[],
    	periods:[],
    	selected_datatype:null,
    	selected_customattribute:null,
    	selected_report:null,
    	selected_reportcolumn:null,
    	selected_project:null,
    	selected_flow:null,
    	selected_period:null,
    	loading_custom_attributes:false,
    	loading_reports:false,
    	loading_reportcolumns:false,
    	loading_projects:false,
    	loading_flows:false,
    	loading_periods:false,
    	canvas:null,
    	objects:[],
    	selectedobj:null,
    	selectedobjtype:null,
    	activetab:0,
    	imageprefix:"https://storage.googleapis.com/verifycloud/",
    	alignoptions:[
    		{ icon: 'pi pi-align-left', value: 'left' },
        { icon: 'pi pi-align-center', value: 'center' },
        { icon: 'pi pi-align-right', value: 'right' },
    	],
    	datatypes:[
    		{ name: 'Supplier Name', id: 'suppliername' },
    		{ name: 'Supplier Code', id: 'suppliercode' },
    		{ name: 'Custom Attribute', id: 'customattribute' },
    		{ name: 'Report Column', id: 'reportcolumn' },
    		{ name: 'Questionlist Percentage', id: 'questionlistpercentage' },
    	],
    	weightoptions:["normal","bold"],
    	fonts:["Times New Roman","Arial","Arial Black","Verdana","Tahoma ","Georgia ","Garamond ","Courier New","Trebuchet MS","Impact","Brush Script MT","Gill Sans","Palatino","Baskerville","Lucida","Monaco","Bradley Hand","Luminari","Comic Sans MS"],
    }
  },
  mounted()
  {
  	
  		const ref = this.$refs.canvas;
	  	this.canvas = new fabric.Canvas(ref);
	  	this.canvas.on('mouse:down', (options)=> {
		  this.detectMouseDown(options)
			});
			this.canvas.on('mouse:down', (options)=> {
		  this.detectMouseUp(options)
			});
			this.canvas.on('object:added', (data)=> {
			  this.detectObjectAdded(data)
			});
			this.canvas.on('selection:created', (data)=> {
			  this.detectObjectSelection(data)
			});
			this.canvas.on('selection:updated', (data)=> {
			  this.detectObjectSelection(data)
			});
			this.canvas.on('object:moving', (data)=> {
			  this.detectObjectMoving(data)
			});
  	
  
  	

  },
  watch:{
  	showmodal(newval)
  	{
  		if(newval)
  		{
  			this.activepageindex = 0
  			this.getData()
  		}
  	}
  },
  computed:{
  	showmodal()
  	{
  		return this.$store.state.document_editor.show_modal
  	},
  	canvas_objects()
  	{
  		if(this.canvas)
  		{
  			return this.canvas._objects
  		}
  		return []
  	},
  	layers()
  	{
  		let layers = []
  		if(this.canvas)
  		{
  			let objects = this.canvas._objects
  			console.log("layers")
	  		for(let item of objects)
	  		{
	  			let type = item.get("type")
	  			console.log(type)
	  			let obj = {
	  				type:type,
	  			}
	  			layers.push(obj)
	  		}
  		}
  		
  		return layers
  	}
  },
  methods:{
  	isPageActive(index)
  	{
  		if(index === this.activepageindex)
  			{return "text-red-500"}
  		else
  		{
  			return "text-primary"
  		}
  	},
  	updatePage()
  	{
  		let _objects = this.canvas._objects
  		let items = []
  		for(let object of _objects)
  		{
  			items.push(this.fabricItemtoJsonData(object))
  		}
  		let formdata = new FormData()
  		formdata.append("content",JSON.stringify(items)) 
  		
  		this.generalSubmission(formdata,"update_supplier_scorecard_page_data/"+this.translation[this.activepageindex].id,this.afterupdatePage)
  	},
  	afterupdatePage(response)
  	{

  	},
  	fabricItemtoJsonData(item)
  	{
  		let obj = {
  			itemtype:item.itemtype,
  			width:item.width,
  			height:item.height,
  			left:item.left,
  			top:item.top,
  			fill:item.fill,
  			fontFamily:item.fontFamily,
  			fontSize:item.fontSize,
  			fontWeight:item.fontWeight,
  			textAlign:item.textAlign,
  			text:item.text,
  			scaleX:item.scaleX,
  			scaleY:item.scaleY,
  			sliderscale:item.sliderscale,
  			datatype:item.datatype,
  			customattribute_id:item.customattribute_id,
  			report_id:item.report_id,
  			reportcolumn_id:item.reportcolumn_id,
  		}
  		if(item.itemtype=="image")
  		{
  			obj.img_url = item.img_url
  			obj.sliderscale = item.sliderscale
  		}

  		return obj
  	},
  	jsonDatatoFabricItem(item)
  	{
  		if(item.itemtype=="textbox")
  		{
  			var text = new fabric.Textbox(item.text, { 
	  			left: item.left, 
	  			top: item.top,
	  			width:item.width,
	  			height:item.height,
	  			fontFamily: item.fontFamily,
	    		fontWeight: item.fontWeight,
	    		textAlign:item.textAlign,
		      hasControls:false,
	  			fontSize:item.fontSize, 
	  			fill:item.fill,
	  			lockMovementX:true,
	  			lockMovementY:true,
		  		itemtype:"textbox"
	  		});
	  		this.canvas.add(text);
  		}
  		if(item.itemtype=="data")
  		{
  				var text = new fabric.Text('Data', { 
		  			left: item.left, 
		  			top: item.top,
		  			width:item.width,
		  			height:item.height,
		  			fontFamily: item.fontFamily,
		    		fontWeight: item.fontWeight,
		    		textAlign:item.textAlign,
			      hasControls:false,
		  			fontSize:item.fontSize, 
		  			fill:item.fill,
		  			datatype:item.datatype,
		  			customattribute_id:item.customattribute_id,
		  			report_id:item.report_id,
		  			reportcolumn_id:item.reportcolumn_id,
		  			questionlist_id:item.questionlist_id,
		  			period_id:item.period_id,
	  				lockMovementX:true,
	  				lockMovementY:true,
		  			itemtype:"data"
		  		});
		  		this.canvas.add(text);
  		}
  		if(item.itemtype=="image")
  		{
  				let img_url = item.img_url
  				
  				fetch(img_url)
			    .then(result => result.blob())
			    .then(blob => {
			    	
			        const url = URL.createObjectURL(blob);
			        fabric.Image.fromURL(url, (img)=> {
			  			img.scaleToWidth(1588);
			  			img.set({  				
				      	hasControls:false,
			  				itemtype:"image",
			  				left: item.left, 
		  					top: item.top,
		  					img_url:img_url,
		  					scaleX:item.sliderscale,
	  					lockMovementX:true,
	  					lockMovementY:true,
		  					scaleY:item.sliderscale,
		  					sliderscale:item.sliderscale,
			  			})
						  this.canvas.add(img);	
						});
			    });
  		}
  	},
  	async trasformTRanslationData()
  	{
  		if(this.translation[this.activepageindex].content)
  		{
  			let content = JSON.parse(this.translation[this.activepageindex].content)
	  		for(let item of content)
	  		{
	  			await this.jsonDatatoFabricItem(item)
	  		}
  		}
  		
  		return "ok"
  	},

  	async getData()
  	{
  			this.canvas.clear()
  			this.loading = true  			
  			this.translation = await this.generalApiGetWithoutLoader("get_supplier_scorecard_page_data/"+this.$store.state.document_editor.editing_translation) 
  			console.log(this.translation)
  			await this.trasformTRanslationData()
  			this.loading = false
  	},
  	async reportSelected()
  	{
  		let item = this.canvas.getActiveObject()
  		item.report_id = this.selected_report
  		this.loading_reportcolumns = true
  		let brandreport = await this.generalApiGetWithoutLoader("brand_report_columns/"+this.selected_report)
  		this.reportcolumns =  await brandreport.columns
  		this.loading_reportcolumns = false

  	},
  	reportColumnSelected()
  	{
  		let item = this.canvas.getActiveObject()
  		item.reportcolumn_id = this.selected_reportcolumn
  	},
  	customAttributeSelected()
  	{
  		let item = this.canvas.getActiveObject()
  		item.customattribute_id = this.selected_customattribute
  	},
  	async dataTypeUpdated(data)
  	{
  		let item = this.canvas.getActiveObject()
  		item.datatype = this.selected_datatype
  		if(this.selected_datatype=="customattribute")
  		{
  			this.loading_custom_attributes = true
  			this.customattributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$route.params.id)
  			this.loading_custom_attributes = false
  		}

  		if(this.selected_datatype=="reportcolumn")
  		{
  			this.loading_reports = true
  			this.reports = await this.generalApiGetWithoutLoader("brand_reports/"+this.$route.params.id)
  			this.loading_reports = false
  		}

  	},
  	getFraction(data)
  	{
  		data = parseFloat(data)
  		return data.toFixed(2)
  	},
  	is_selected(obj)
  	{
  		if(obj == this.canvas.getActiveObject())
  		{
  			return "red-500"
  		}

  		return "primary"
  	},
  	getItemName(index)
  	{
  		let element = this.canvas.item(index)
  		
  		let type = element.get("type")
  		
  		let name
  		if(type=="textbox")
  		{
  			name = element.get("text").slice(0, 25);
  		}
  		if(type=="image")
  		{
  			name = "image"
  		}
  		if(type=="text")
  		{
  			name = "data"
  		}
  		//let name = element.get("text").slice(0, 25);
  		return name
  	},
  	deleteLayer(index)
  	{
  		let item = this.canvas.item(index)
  		this.canvas.remove(item)
  		this.canvas.renderAll();

  	},
  	addNewPage()
  	{
  		console.log(this.translation)
  		let first_page = this.translation[0]
  		console.log(first_page)
  		let formdata = new FormData()
  		this.generalSubmission(formdata,"submit_supplier_scorecard_page/"+first_page.supplierscorecardtranslation_id,this.afterNewPage)

  	},
  	afterNewPage(response)
  	{
  		this.activepageindex = this.activepageindex+1
  		this.getData()
  	},
  	async selectPage(index)
  	{
  		console.log("select page")
  		this.activepageindex = index
  		this.getData()
  		
  		
  	},
  	deletePage(index)
  	{
  		let formdata = new FormData()
  		let page = this.translation[index]

  		this.generalSubmission(formdata,"delete_supplier_scorecard_page/"+page.id,this.afterdeletePage)
  	},
  	afterdeletePage(response)
  	{
  		this.activepageindex = 0
  		this.getData()
  	},
  	editItem(index)
  	{
  		let element = this.canvas.item(index)
  		this.canvas.setActiveObject(element);
  		this.activetab = 1
  	},
  	detectMouseDown(options)
  	{
  	  //console.log(options)
	  //console.log(options.e.clientX, options.e.clientY);
	  //console.log(this.canvas._objects)
		  if(!this.canvas.getActiveObject())
		  {
		  	this.selectedobj = null
		  	this.selectedobjtype = null
		  }
  	},
  	detectMouseUp(data)
  	{
  	  //console.log(options)
	  //console.log(options.e.clientX, options.e.clientY);
	  //console.log(this.canvas._objects)
		  if(this.canvas.getActiveObject())
		  {
		  	//this.selectedobj.top = data.e.clientY
  		  //this.selectedobj.left = data.e.clientX
		  }
  	},
  	detectObjectAdded(data)
  	{
  	  
  	},
  	detectObjectMoving(data)
  	{
  		
  		
  	},
  	async detectObjectSelection(data)
  	{
  		
  		this.selectedobjtype = this.canvas.getActiveObject().get('type')
  		this.selectedobj = this.canvas.getActiveObject()
  		this.activetab = 1

  		this.selected_datatype = this.selectedobj.datatype
  		

  		if(this.selectedobj.datatype=="customattribute")
  		{
  			
  			this.customattributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$route.params.id)
  			this.selected_customattribute = this.selectedobj.customattribute_id
  		}
  		if(this.selectedobj.datatype=="reportcolumn")
  		{
  			
  			this.reports = await this.generalApiGetWithoutLoader("brand_reports/"+this.$route.params.id)
  			this.selected_report = this.selectedobj.report_id
  			let brandreport = await this.generalApiGetWithoutLoader("brand_report_columns/"+this.selected_report)
  			this.reportcolumns =  await brandreport.columns
  			this.selected_reportcolumn = this.selectedobj.reportcolumn_id
  		}
  	},
  	closeModal()
  	{
  		this.canvas.clear()
  		this.selectedobj = null
	  	this.selectedobjtype = null
	  	this.activetab = 0
  		this.$store.dispatch('document_editor/setShowModal',false) 
  	},
  	addRect()
  	{
  		const rect = new fabric.Rect({
	      fill: 'red',
	      width: 200,
	      height: 200,
	      hasControls:false,

	    });
	    this.canvas.add(rect);
  	},
  	addImage()
  	{
  		this.$refs.imageuploader.click()
  	},
  	uploadImage(event)
  	{
  		
  		let files = this.$refs.imageuploader.files[0]
  		
  		this.imageuploading = true
  		let formdata = new FormData()

  		formdata.append("brand_id",this.$route.params.id)   
  		formdata.append("files",files)    
      //formdata.append("data",JSON.stringify(this.fields))
      this.generalSubmission(formdata,"store_scorecard_media",this.afteruploadImage)
  	},
  	afteruploadImage(response)
  	{
  		
  		this.imageuploading = false
  		/*
  		fabric.Image.fromURL(this.imageprefix+response.data, (img)=> {
  			img.scaleToWidth(1588);
  			img.set({  				
	      	hasControls:false,
  			})
			  this.canvas.add(img);
			  this.activetab = 1
			  this.canvas.setActiveObject(this.canvas.item(this.canvas._objects.length-1));
			});




			fabric.util.loadImage(img_url, (img)=> {
		    var object = new fabric.Image(img);
		    object.scaleToWidth(1588);
		    object.set({
		      hasControls:false,
		    });
		    this.canvas.add(object);
		    this.canvas.renderAll();
		    this.activetab = 1
			  this.canvas.setActiveObject(this.canvas.item(this.canvas._objects.length-1));

		  })


			*/

			let img_url = this.imageprefix+response.data


			fetch(img_url)
	    .then(result => result.blob())
	    .then(blob => {
	        const url = URL.createObjectURL(blob);
	        fabric.Image.fromURL(url, (img)=> {
	  			img.scaleToWidth(1588);
	  			img.set({  				
		      	hasControls:false,
	  				itemtype:"image",
	  				lockMovementX:true,
	  				lockMovementY:true,
	  				sliderscale:1,
	  				img_url:img_url,
	  			})
				  this.canvas.add(img);
				  this.activetab = 1
				  this.canvas.setActiveObject(this.canvas.item(this.canvas._objects.length-1));
				});
	    });







			 










  	},
  	downloadPdf()
  	{
  		var imgData = this.canvas.toDataURL("image/jpeg", 1.0);
  		var pdf = new jsPDF("p", "px", "a4");

		  pdf.addImage(imgData, 'JPEG', 0, 0,397,562);
		  pdf.save("download.pdf");
  	},
  	addData()
  	{
  			var text = new fabric.Text('Data', { 
	  			left: 100, 
	  			top: 100,
	  			width:150,
	  			height:50,
	  			fontFamily: 'Arial',
	    		fontWeight: 'normal',
	    		textAlign:"left",
		      hasControls:false,
	  			fontSize:20, 
	  			fill:"#000000",
	  			datatype:null,
	  			customattribute_id:null,
	  			report_id:null,
	  			reportcolumn_id:null,
	  			questionlist_id:null,
	  			period_id:null,
	  			lockMovementX:true,
	  			lockMovementY:true,
	  			itemtype:"data"
	  		});
	  		this.canvas.add(text);
	  		this.activetab = 1
	  		this.canvas.setActiveObject(this.canvas.item(this.canvas._objects.length-1));
  	},
  	addTextBox()
  	{
  		var text = new fabric.Textbox('Sample Text', { 
  			left: 100, 
  			top: 100,
  			width:150,
  			height:50,
  			fontFamily: 'Arial',
    		fontWeight: 'normal',
    		textAlign:"left",
	      hasControls:false,
  			fontSize:20, 
  			fill:"#000000",
	  			lockMovementX:true,
	  			lockMovementY:true,
	  		itemtype:"textbox"
  		});
  		this.canvas.add(text);
  		this.activetab = 1
  		this.canvas.setActiveObject(this.canvas.item(this.canvas._objects.length-1));
  	},
  	textUpdated(data)
  	{
  		let text = this.canvas.getActiveObject()
  		text.text = data
  		this.canvas.renderAll();

  	},
  	textFontFamilyUpdated(data)
  	{
  		let text = this.canvas.getActiveObject()
  		text.fontFamily = data.value
  		setTimeout(()=>{
  			this.canvas.renderAll();
  		},50)
  		
  	},
  	textColorUpdated(data)
  	{  		
  		this.canvas.getActiveObject().set("fill", "#"+data);
  		this.canvas.renderAll();
  	},
  	textAlignUpdated(data)
  	{
  		this.canvas.getActiveObject().set("textAlign", data.value.value);
  		this.canvas.renderAll();
  	},
  	textFontWeightUpdated(data)
  	{
  		let element = this.canvas.getActiveObject()
  		element.fontWeight = data.value
  		this.canvas.renderAll();
  	},	
  	textFontsizeUpdated(data)
  	{
  		
  		
  		let text = this.canvas.getActiveObject()
  		text.fontSize = data
  		setTimeout(()=>{
  			this.canvas.renderAll();
  		},50)
  	},
  	imageScaleUpdated()
  	{
  		let text = this.canvas.getActiveObject()
  		text.scaleY = this.selectedobj.sliderscale
  		text.scaleX = this.selectedobj.sliderscale
  		this.canvas.renderAll();
  	},
  	imageScaleYUpdated(data)
  	{
  		console.log(data)
  		let text = this.canvas.getActiveObject()
  		text.set("scaleY", data);
  		this.canvas.renderAll();

  	},
  	imageScaleXUpdated(data)
  	{
  		let text = this.canvas.getActiveObject()
  		text.set("scaleX", data);
  		this.canvas.renderAll();
  	},
  	textLeftUpdated(data)
  	{
  		
  		this.canvas.getActiveObject().set("left", parseInt(data));
  		this.canvas.renderAll();
  	},
  	textTopUpdated(data)
  	{
  		
  		this.canvas.getActiveObject().set("top", parseInt(data));
  		this.canvas.renderAll();
  	},
  	textWidthUpdated(data)
  	{
  		this.canvas.getActiveObject().set("width", data);
  		this.canvas.renderAll();
  	},
  	textHeightUpdated(data)
  	{
  		this.canvas.getActiveObject().set("height", data);
  		this.canvas.renderAll();
  	},
  }
}
</script>

<style lang="css" scoped>
	.zebra_grid:hover{
		background-color: #efefef;
		box-shadow: rgb(93 62 188 / 16%) 0px 6px 10px;
		cursor: pointer;
	}
.scorecard_editor{
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100vh;
	background-color: rgba(0,0,0,0.7);
	z-index: 100;
}
.scorecard_editor_inner{
	position: relative;
	width: 98%;
	height: 98vh;
	margin: 1vh 1%;
	padding: 10px;
	background-color: #fff;
	border-radius: 5px;
}
.editor_pdf_area_holder {
    scrollbar-width: auto;
    scrollbar-color: #352f8d #ffffff;
  }

  /* Chrome, Edge, and Safari */
  .editor_pdf_area_holder::-webkit-scrollbar {
    width: 9px;
  }

  .editor_pdf_area_holder::-webkit-scrollbar-track {
    background: #ffffff;
  }

  .editor_pdf_area_holder::-webkit-scrollbar-thumb {
    background-color: #352f8d;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }
  .editor_pdf_area_holder{
  	background-color: #aaa;
  	border-radius: 5px;
  	padding: 10px;
  	height: 90vh;
		overflow-y: scroll;
		overflow-x: hidden;
  }
.editor_pdf_area{
	width: 1588px;
	min-height: 2246px;
	position: relative;
	background-color: #fff;
	scale: 0.5;
	transform-origin: top center;
}
.editor_controllers_area_holder{
	
}
.editor_controllers_area{

	position: sticky;
	top: 20px;

}
.editor_controllers_area>div{
	height: 85vh;
	overflow-y: scroll;
}
.editor_controllers_area>div {
    scrollbar-width: auto;
    scrollbar-color: #352f8d #ffffff;
  }

  /* Chrome, Edge, and Safari */
  .editor_controllers_area>div::-webkit-scrollbar {
    width: 9px;
  }

  .editor_controllers_area>div::-webkit-scrollbar-track {
    background: #ffffff;
  }

  .editor_controllers_area>div::-webkit-scrollbar-thumb {
    background-color: #352f8d;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }

</style>